import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { DRAWER_WIDTH } from '../../layouts/constants';

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}));

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  background: '#00010E',
  ...(open && {
    marginLeft: DRAWER_WIDTH,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

const primary = () => ({
  width: DRAWER_WIDTH,
  background: '#00010E',
  overflowX: 'hidden',
  transition: 'background 0.5s ease-in-out'
});

const secondary = () => ({
  width: DRAWER_WIDTH,
  background: '#01031A',
  overflowX: 'hidden',
  transition: 'background 0.5s ease-in-out'
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, secondaryOpen }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(!secondaryOpen && {
    ...primary(theme),
    '& .MuiDrawer-paper': primary(theme)
  }),
  ...(secondaryOpen && {
    ...secondary(theme),
    '& .MuiDrawer-paper': secondary(theme)
  })
}));

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#00010E',
    boxShadow: theme.shadows[1],
    fontWeight: 300,
    fontSize: 14,
    lineHeight: '24px'
  }
}));
